module.exports = __webpack_public_path__ + "media/images/app-green-circle-3c872a356cf29dad46b4148d169de990.png";